<template>
  
    <div class="home"> 
        <div class="card">
            <div class="card-header">
                <h3 class="card-title">Portal Acadêmico</h3> 
            </div>
            <div class="card-body">
                <h3 v-if="comandante">Comandante da APM: {{ comandante.valor }}</h3>
                Ferramenta desenvolvida para gestão acadêmica dos cursos na PMES. <br><br>
                As principais funcionalidades são:<br><br> 
                • Aos gestores da APM: ferramentas para gestão das turmas, tais como, controle de aulas dadas, faltas e notas;<br><br> 
                • Aos professores: lançamento de aulas dadas e notas de provas; <br><br>
                • Aos alunos de curso em andamento: Boletim Escolar on-line; <br><br>
                • Aos alunos formados: Emissão de certificado e histórico escolar. <br><br>
                O acesso é feito utilizando o mesmo usuário e senha do Portal PMES. <br><br>
                A quem se destina: Todos os policiais militares e professores credenciados pela DEIP. <br><br>
                Informações adicionais podem ser obtidas nos seguintes contatos: <br><br>
                Telefone: (27) 3636-2976 (SAE/APM/PMES) <br><br>
                E-mail: sae.apmes@pm.es.gov.br <br><br>
                Termo de Uso da ferramenta: BGPM nº 031/2020.  
            </div>
            <div class="card-footer">
                 
            </div>
        </div>
    </div>

</template>

<script lang="ts">
    import { Options, Vue  } from "vue-class-component"; 
    import ConfiguracaoService from   "@/service/v10/sigap/ConfiguracaoService"  


    @Options({
        name: "Sobre",
        components: { },  
    }) 
    export default class Sobre extends Vue {
       
        public configuracaoService = new ConfiguracaoService(); 
        public comandante: any = null

        created(){ 
            this.buscaComandante();
        }

        public buscaComandante(){   
           
            this.configuracaoService.getModelByChave( 'comandante_apm'  ) 
            .then(response => {   
                this.comandante =  JSON.parse(JSON.stringify( response ));   
                 
            })
            .catch(error => { 
                console.log(error); 
            }); 
        } 

    } 
 
</script>


<style scoped> 
    .sobre-lista{
        margin-top: 20px !important; 
    }
</style>